// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wi_a bht_b","TwoDimsListFeature__item":"wi_b bht_we","TwoDimsListFeature__item__text":"wi_c bht_vt"};